<!--  -->
<template>
  <el-table :data="tableData" style="width: 100%" stripe>
    <el-table-column prop="f_specimen_number" label="Specimen ID" width="125">
      <template slot-scope="scope">
        <div
          @click="openDetails(scope.row.fossil_id)"
          v-html="scope.row.f_specimen_number"
        >
          <!-- {{}} -->
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="f_storage_institute"
      label="Custodian Institute"
      min-width="33%"
    >
      <template slot-scope="scope">
        <div
          @click="openDetails(scope.row.fossil_id)"
          v-html="scope.row.f_storage_institute"
        >
          <!-- {{}} -->
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="f_site_place"
      label="Fossil Locality"
      min-width="33%"
    >
      <template slot-scope="scope">
        <div
          @click="openDetails(scope.row.fossil_id)"
          v-html="scope.row.f_site_place"
        >
          <!-- {{}} -->
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="f_chronostratigraphy_series"
      label="Series"
      width="80"
    >
      <template slot-scope="scope">
        <div
          @click="openDetails(scope.row.fossil_id)"
          v-html="scope.row.f_chronostratigraphy_series"
        >
          <!-- {{}} -->
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="f_chronostratigraphy_stage" label="Stage" width="80">
      <template slot-scope="scope">
        <div
          @click="openDetails(scope.row.fossil_id)"
          v-html="scope.row.f_chronostratigraphy_stage"
        >
          <!-- {{}} -->
        </div>
      </template>
    </el-table-column>
    <!-- <el-table-column prop="f_cover_img" label="Images" width="80">
      <template slot-scope="scope">
        <el-image
          class="image"
          :src="defaultImgHeader + scope.row.f_cover_img + ossImage"
          fit="fill"
          :preview-src-list="[defaultImgHeader + scope.row.f_cover_img]"
        >
          <div slot="error" class="image-slot">
            No Image<span class="dot">...</span>
          </div>
        </el-image>
      </template>
    </el-table-column> -->
    <el-table-column
      prop="f_lithostratigraphy_formation"
      label="Formation"
      width="120"
    >
      <template slot-scope="scope">
        <div
          @click="openDetails(scope.row.fossil_id)"
          v-html="scope.row.f_lithostratigraphy_formation"
        >
          <!-- {{}} -->
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { deepBoneDomin, ossImage } from "@/common.js";
import { utlogMap } from "../../api";
export default {
  props: ["tableData"],
  data() {
    return {
      defaultImgHeader: deepBoneDomin,
      ossImage: ossImage,
      routerName: "",
      tibetName: "TibetPlateau",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.routerName = this.$route.name;
  },
  methods: {
    openDetails(fossil_id) {
      let functionId = {
        functionId:
          this.routerName == this.tibetName
            ? "Deepbone_tibet_specimensPageOpen"
            : "Deepbone_explore_specimensPageOpen",
      };
      let logMap = {
        eventType: "clk",
        url: window.location.href,
        functionId: functionId.functionId,
      };
      utlogMap(logMap).then((res) => {
        // console.log(res);
      });
      this.$router.push({
        name: "fossilDetails",
        params: { fossil_id, ...functionId },
      });
    },
    cellClick(cell) {
      console.log(cell);
    },
  },
};
</script>
<style>
.el-table th.el-table__cell > .cell {
  font-weight: 600;
}
</style>
